<template>
  <div>
    <cabecalho :ar="arAndCertificate"></cabecalho>
    <div class="app-content">
      <div class="heading">Solicitação de certificado digital</div>
      <b-card class="shadow-sm mb-2 bg-white rounded">
        <wizard :steps="wizardSteps" :activeIndex="wizardActiveIndex"></wizard>
        <hr />
        <b-alert v-model="showErro" variant="danger">{{mensagemErro}}</b-alert>
        <div v-if="initialLoading" class="text-center" style="margin-top: 4rem;">
          <b-spinner label="Loading..."></b-spinner>
        </div>
        <div v-if="!initialLoading">
          <validation-observer ref="observer" v-slot="{ passes }">
            <b-form @submit.stop.prevent="passes(enviar)">

              <validation-provider
                name="orgaoContratante"
                v-if="arAndCertificate.institucional"
                rules="required"
                v-slot="validationContext"
                :immediate="validacaoOrgaoImediata"
              >

                <b-form-group
                  id="example-input-group-orgaoContratante"
                  label="Órgão"
                  label-for="sel-orgao">

                  <b-form-select
                    id="sel-orgao"
                    name="sel-orgao"
                    v-model.number="credenciais.orgaoContratanteId"
                    :state="getValidationState(validationContext)"
                    aria-describedby="sel-orgao-helper">
                      <template #first>
                        <b-form-select-option :value="null" disabled>-- Selecione uma opção --</b-form-select-option>
                      </template>
                      <option v-for="oc in arAndCertificate.orgaosContratantes" :value="oc.id" v-bind:key="oc.id">{{ oc.sigla }} - {{oc.nome}}</option>
                  </b-form-select>
                  <b-form-invalid-feedback id="sel-orgao-live-feedback">
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                  <b-form-text>
                    Órgão que está viabilizando a solicitação do certificado digital.
                  </b-form-text>
                </b-form-group>

              </validation-provider>

              <validation-provider
                vid="sslCN"
                v-if="arAndCertificate.equipamento"
                name="SSLCN"
                rules="required"
                v-slot="validationContext"
              >
                <b-form-group id="example-input-group-e" label="Domínio" label-for="input-cn">
                  <b-form-input
                    :state="getValidationState(validationContext) && cnValidation.isValid"
                    id="input-cn"
                    name="input-cn"
                    maxlength="64"
                    v-model="credenciais.sslCN"
                    aria-describedby="input-e-live-feedback"
                    @change="validateDomain(credenciais.sslCN,'loading-dominio', cnValidation, 'sslCN');"
                    :disabled="cnValidation.isValidating"
                  ></b-form-input>
                  <b-spinner
                    id="loading-dominio"
                    style="display:none; float:right; margin-top:-1.7rem; margin-right:0.68rem;"
                    small
                    type="grow"
                  ></b-spinner>

                  <b-form-invalid-feedback
                    id="input-e-live-feedback"
                  >{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                  <b-form-text>
                    Ex:
                    <b>seudominio.com.br</b>, ou, para vários subdomínios,
                    <b>*.seudominio.com.br</b>.
                  </b-form-text>
                </b-form-group>
              </validation-provider>
              <div v-if="arAndCertificate.multidominio">
                <validation-provider
                  v-for="(domain, index) in alternativeDomains"
                  v-bind:key="'dna' + index"
                  :vid="'viddna' +index"
                  :name="'name-input-dna' + index"
                  v-slot="validationContext"
                >
                  <b-form-group
                    id="example-input-group-dna"
                    :label="index == 0?'Domínios Adicionais':''"
                    label-for="input-dna"
                  >
                    <div class="input-group mb-3">
                      <b-form-input
                        :id="'input-dna'+index"
                        :name="'input-dna'+index"
                        maxlength="253"
                        :aria-describedby="'dnafeedback' + index"
                        :state="getValidationState(validationContext) && alternativeDomains[index].cnValidation.isValid"
                        v-model="alternativeDomains[index].domain"
                        :disabled="alternativeDomains[index].cnValidation.isValidating"
                        @change="validateDomain(alternativeDomains[index].domain,'loading-dominio' + index, alternativeDomains[index].cnValidation, 'viddna' +index);"
                      />
                      <div class="input-group-append">
                        <b-spinner
                          :id="'loading-dominio' + index"
                          style="display:none;position: absolute;right: 3.8rem;top: 0.70rem;"
                          small
                          type="grow"
                        ></b-spinner>
                        <b-popover
                          v-if="index == maximoDominiosAdicionais - 1"
                          :target="'plus-domain'+ (maximoDominiosAdicionais-1)"
                          triggers="focus"
                          placement="topleft"
                        >São permitidos apenas {{maximoDominiosAdicionais}} domínios adicionais.</b-popover>
                        <b-button
                          :id="'plus-domain'+ index"
                          class="btn-sd btn-domains"
                          v-if="index == alternativeDomains.length -1"
                          variant="secondary"
                          type="button"
                          @click="newDomain(alternativeDomains)"
                        >+</b-button>
                        <b-button
                          class="btn-sd btn-domains"
                          v-else
                          variant="secondary"
                          type="button"
                          @click="alternativeDomains.splice(index,1)"
                          :disabled="validatingForm"
                        >-</b-button>
                      </div>

                      <b-form-invalid-feedback
                        :id="'dnafeedback' + index"
                        style="float:left"
                      >{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </div>
                    <b-form-text
                      v-if="index == alternativeDomains.length -1"
                      style="margin-top: -0.75rem;"
                    >
                      Pressione
                      <b>+</b> para adicionar um novo domínio.
                    </b-form-text>
                  </b-form-group>
                </validation-provider>
              </div>
              <validation-provider
                v-if="arAndCertificate.pj || arAndCertificate.equipamento"
                name="CNPJ"
                rules="required|cnpj"
                v-slot="validationContext"
              >
                <b-form-group id="example-input-group-0" label="CNPJ" label-for="input-cnpj">
                  <b-form-input
                    id="input-cnpj"
                    name="input-cnpj"
                    v-model="credenciais.cnpj"
                    v-mask="'##.###.###/####-##'"
                    :state="getValidationState(validationContext)"
                    aria-describedby="input-0-live-feedback"
                  ></b-form-input>

                  <b-form-invalid-feedback
                    id="input-0-live-feedback"
                  >{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>

              <validation-provider
                v-if="!arAndCertificate.consultaPrevia && (arAndCertificate.pj || arAndCertificate.equipamento) "
                name="NOME-EMPRESARIAL"
                :rules='{ required: true, regex: validInputRegex }'
                v-slot="validationContext"
              >
                <b-form-group id="input-group-nome-empresarial"
                  label="NOME EMPRESARIAL CONSTANTE NO CNPJ"
                  label-for="input-nome-empresarial">
                  <b-form-input
                    id="input-nome-empresarial"
                    name="input-nome-empresarial"
                    maxlength="64"
                    v-model="credenciais.nomeEmpresarial"
                    :state="getValidationState(validationContext)"
                    aria-describedby="input-nome-empresarial-live-feedback"
                    class="text-uppercase"
                    trim
                  ></b-form-input>

                  <b-form-invalid-feedback
                    id="input-nome-empresarial-live-feedback"
                  >{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>

              <validation-provider name="CPF" rules="required|cpf" v-slot="validationContext">
                <b-form-group
                  id="example-input-group-1"
                  :label="arAndCertificate.equipamento || arAndCertificate.pj ? 'CPF DO REPRESENTANTE LEGAL':'CPF'"
                  label-for="input-cpf"
                >
                  <b-form-input
                    id="input-cpf"
                    name="input-cpf"
                    v-model="credenciais.cpf"
                    v-mask="'###.###.###-##'"
                    :state="getValidationState(validationContext)"
                    aria-describedby="input-1-live-feedback"
                  ></b-form-input>

                  <b-form-invalid-feedback
                    id="input-1-live-feedback"
                  >{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>

              <validation-provider name="NOME-PF"
                v-if="!arAndCertificate.consultaPrevia && arAndCertificate.pf"
                :rules='{ required: true, regex: validInputRegex }'
                v-slot="validationContext">
                <b-form-group
                  id="input-group-nome-pf"
                  label="NOME"
                  label-for="input-nome-pf"
                >
                  <b-form-input
                    id="input-nome-pf"
                    name="input-nome-pf"
                    v-model="credenciais.nomeResponsavelUso"
                    class="text-uppercase"
                    maxlength="64"
                    :state="getValidationState(validationContext)"
                    aria-describedby="input-nome-pf-live-feedback"
                    trim
                  ></b-form-input>

                  <b-form-invalid-feedback
                    id="input-nome-pf-live-feedback"
                  >{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>

              <validation-provider name="NOME-REPRESENTANTE"
                v-if="!arAndCertificate.consultaPrevia && (arAndCertificate.pj || arAndCertificate.equipamento) "
                :rules='{ required: true, regex: validInputRegex }'
                v-slot="validationContext">
                <b-form-group
                  id="input-group-nome-representante"
                  label="NOME DO REPRESENTANTE LEGAL"
                  label-for="input-nome-representante"
                >
                  <b-form-input
                    id="input-nome-representante"
                    name="input-nome-representante"
                    v-model="credenciais.nomeRepresentante"
                    maxlength="64"
                    :state="getValidationState(validationContext)"
                    aria-describedby="input-nome-representante-live-feedback"
                    class="text-uppercase"
                    trim
                  ></b-form-input>

                  <b-form-invalid-feedback
                    id="input-nome-representante-live-feedback"
                  >{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>

              <validation-provider
                name="Nascimento"
                rules="required|min:10"
                v-slot="validationContext"
              >
                <b-form-group
                  id="example-input-group-2"
                  :label="arAndCertificate.equipamento || arAndCertificate.pj ? 'NASCIMENTO DO REPRESENTANTE LEGAL' : 'DATA DE NASCIMENTO'"
                  label-for="input-nascimento"
                >
                  <b-form-input
                    id="input-nascimento"
                    name="input-nascimento"
                    v-model="credenciais.nascimento"
                    v-mask="'##/##/####'"
                    :state="getValidationState(validationContext)"
                    aria-describedby="input-2-live-feedback"
                  ></b-form-input>

                  <b-form-invalid-feedback
                    id="input-2-live-feedback"
                  >{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>

              <b-form-group
                v-if="arAndCertificate.equipamento || arAndCertificate.pj"
                id="ask-ru"
                label-for="ask-ru-cb"
              >
                <b-form-checkbox
                  value="accepted"
                  v-model="showResponsavelUso"
                  id="ask-ru-cb"
                >Outra pessoa será responsável pelo uso do certificado</b-form-checkbox>
              </b-form-group>
              <div v-if="showResponsavelUso">
                <validation-provider
                  name="CPFRU"
                  rules="required|cpf"
                  v-slot="validationContext"
                >
                  <b-form-group
                    id="example-input-group-cpfru"
                    label="CPF do responsável pelo uso"
                    label-for="input-cpfru"
                  >
                    <b-form-input
                      id="input-cpfru"
                      name="input-cpfru"
                      v-model="credenciais.cpfResponsavelUso"
                      v-mask="'###.###.###-##'"
                      :state="getValidationState(validationContext)"
                      aria-describedby="input-ru-live-feedback"
                    ></b-form-input>

                    <b-form-invalid-feedback
                      id="input-ru-live-feedback"
                    >{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>

                <validation-provider name="NOMERU"
                v-if="!arAndCertificate.consultaPrevia && !arAndCertificate.pf"
                :rules='{ required:true, regex: validInputRegex }'
                v-slot="validationContext">
                <b-form-group
                  id="input-group-nomeru"
                  label="NOME do responsável pelo uso"
                  label-for="input-nomeru"
                >
                  <b-form-input
                    id="input-nomeru"
                    name="input-nomeru"
                    v-model="credenciais.nomeResponsavelUso"
                    class="text-uppercase"
                    maxlength="64"
                    :state="getValidationState(validationContext)"
                    aria-describedby="input-nomeru-live-feedback"
                    trim
                  ></b-form-input>

                  <b-form-invalid-feedback
                    id="input-nomeru-live-feedback"
                  >{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>

                <validation-provider
                  name="NascimentoRU"
                  rules="required|min:10"
                  v-slot="validationContext"
                >
                  <b-form-group
                    id="example-input-group-nru"
                    label="Nascimento do Responsável pelo Uso"
                    label-for="input-nascimento-ru"
                  >
                    <b-form-input
                      id="input-nascimento-ru"
                      name="input-nascimento-ru"
                      v-model="credenciais.nascimentoResponsavelUso"
                      v-mask="'##/##/####'"
                      :state="getValidationState(validationContext)"
                      aria-describedby="input-nru-live-feedback"
                    ></b-form-input>

                    <b-form-invalid-feedback
                      id="input-nru-live-feedback"
                    >{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </div>
              <hr />
              <b-button
                type="submit"
                variant="primary"
                v-if="!loading"
                class="btn-sd"
                style="float:right"
                :disabled="validatingForm"
              >Continuar</b-button>

              <b-button
                variant="primary"
                disabled
                v-if="loading"
                class="btn-sd"
                style="float:right"
              >
                <b-spinner small type="grow"></b-spinner>&nbsp;Consultando...
              </b-button>
            </b-form>
          </validation-observer>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import cabecalho from "./components/Cabecalho.vue";
import wizard from "./components/Wizard.vue";

export default {
  components: {
    cabecalho,
    wizard,
  },
  data() {
    return {
      wizardSteps: [],
      wizardActiveIndex: 0,
      validInputRegex: /^[a-zA-Z0-9 !"#$%&')(\\\\\\.\\*+,-/:;=?@]*$/,
      credenciais: {
        cpf: null,
        nomeResponsavelUso: null,
        nomeRepresentante: null,
        cnpj: null,
        nomeEmpresarial: null,
        nascimento: null,
        certificateTemplateId: this.$route.params.templateId,
        sslCN: null,
        subjectAltNames: [],
        cpfResponsavelUso: null,
        nascimentoResponsavelUso: null,
        orgaoContratanteId: null,
      },
      mensagemErro: null,
      showErro: false,
      loading: false,
      initialLoading: false,
      arAndCertificate: {
        arAbbreviation: null,
        certificateTemplateName: null,
        certificateTemplateId: null,
        pj: null,
        equipamento: null,
        institucional: null,
        consultaPrevia: null,
        orgaosContratantes: [],
      },
      cnValidation: {
        isValid: null,
        validationMessages: [],
      },
      validatingForm: false,
      showResponsavelUso: false,
      alternativeDomains: [
        {
          domain: "",
          cnValidation: {
            isValid: null,
            validationMessages: [],
            isValidating: false,
          },
        },
      ],
      maximoDominiosAdicionais: 7,
      validacaoOrgaoImediata: false,
    };
  },
  created() {
    this.obterArAndCertificate();
  },
  watch: {
    showResponsavelUso: function (newValue) {
      if (!newValue) {
        this.credenciais.cpfResponsavelUso = null;
        this.credenciais.nascimentoResponsavelUso = null;
      }
    },
  },
  methods: {
    enviar: function () {
      this.loading = true;
      this.showErro = false;
      //console.log(this.alternativeDomains);
      this.copyAlternativeDomains();
      this.$http.post(this.$serviceUrl + "/order", this.credenciais).then(
        (resp) => {
          sessionStorage.setItem("token", resp.bodyText);
          this.$router.push("/order/step/contacts");
        },
        (resp) => {
          if (resp.status == 404) {
            this.mensagemErro = "Pessoa Física não encontrada";
          } else {
            this.mensagemErro = resp.body.message;
          }
          this.showErro = true;
          this.loading = false;
        }
      );
    },
    obterArAndCertificate: function () {
      this.showErro = false;
      this.initialLoading = true;
      this.$http
        .get(
          this.$serviceUrl +
            "/registerauthority/certificate/" +
            this.credenciais.certificateTemplateId
        )
        .then(
          (resp) => {
            this.arAndCertificate = resp.body;
            sessionStorage.setItem(
              "arAndCertificate",
              JSON.stringify(this.arAndCertificate)
            );
            document.body.style.setProperty(
              "--main-color",
              this.arAndCertificate.mainColor
            );
            document.body.style.setProperty(
              "--main-color-darker-alpha8",
              this.arAndCertificate.mainColorDarkerAlpha8
            );
            document.body.style.setProperty(
              "--main-color-darker-alpha2",
              this.arAndCertificate.mainColorDarkerAlpha2
            );

            this.checarValorUnicoOrgao();

            this.buildWizard();

            this.initialLoading = false;
          },
          (resp) => {
            if (resp.status == 404) {
              this.mensagemErro = "Certificado não encontrado.";
            } else {
              this.mensagemErro = resp.body.message;
            }
            this.showErro = true;
            this.initialLoading = false;
          }
        );
    },
    buildWizard: function(){
      this.wizardSteps = ["Identificação", "Contato", "Informações Adicionais", "Confirmação"];
    },
    validateDomain: function (sslCN, loadingId, cnValidation, vid) {
      if (sslCN.trim().length == 0) {
        return;
      }
      if (document.getElementById(loadingId)) {
        document.getElementById(loadingId).style.display = "block";
      }
      this.showErro = false;
      this.validatingForm = true;
      cnValidation.isValidating = true;
      var cnModel = {
        certificateTemplateId: this.credenciais.certificateTemplateId,
        sslCN: sslCN,
      };
      this.$http
        .post(this.$serviceUrl + "/order/validate/ssl/cn", cnModel)
        .then(
          (resp) => {
            cnValidation.isValid = resp.body.isValid;
            cnValidation.validationMessages = resp.body.validationMessages;
            if (!cnValidation.isValid) {
              var errors = new Object();
              errors[vid] = cnValidation.validationMessages;
              this.$refs.observer.setErrors(errors);
            }
            this.validatingForm = false;
            cnValidation.isValidating = false;
            if (document.getElementById(loadingId)) {
              document.getElementById(loadingId).style.display = "none";
            }
          },
          (resp) => {
            if (resp.status == 404) {
              this.mensagemErro = "Não foi possível validar o domínio";
              this.showErro = true;
            }
            if (resp.status == 412) {
              var errors = new Object();
              errors[vid] = resp.body.message;
              this.$refs.observer.setErrors(errors);
            } else {
              this.mensagemErro = resp.body.message;
              this.showErro = true;
            }
            cnValidation.isValid = false;
            if (document.getElementById(loadingId)) {
              document.getElementById(loadingId).style.display = "none";
            }
            this.validatingForm = false;
            cnValidation.isValidating = false;
          }
        );
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    newDomain: function (alternativeDomains) {
      if (alternativeDomains.length == this.maximoDominiosAdicionais) {
        return;
      }
      alternativeDomains.push({
        domain: "",
        cnValidation: {
          isValid: null,
          validationMessages: [],
          isValidating: false,
        },
      });
    },
    copyAlternativeDomains: function () {
      this.alternativeDomains.forEach((element) => {
        if (element.domain.trim().length != 0) {
          this.credenciais.subjectAltNames.push(element.domain);
        }
      });
    },
    checarValorUnicoOrgao: function() {
      if( this.arAndCertificate.orgaosContratantes != null && this.arAndCertificate.orgaosContratantes.length == 1) {
        this.validacaoOrgaoImediata = true;
        this.credenciais.orgaoContratanteId = this.arAndCertificate.orgaosContratantes[0].id;
      }
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/Order.vue